export default __webpack_public_path__ + "island2.f10f2b6907a58bb3b801d1124318a753.png";